import stAddressAutocomplete from './addressAutocomplete.directive';

let mapsLoaded = false;
export default angular
  .module('st.Core.GoogleMaps', [])
  .directive('stAddressAutocomplete', stAddressAutocomplete)
  .constant('GOOGLEMAPS', {
    restrictToCountries: { country: ['AU', 'NZ'] }
  })
  .run(/* @ngInject */ function ($window) {
    if (!mapsLoaded || !$window.google || !window.google.maps || !window.google.maps.places) {
      $window.googleMapsLoaded = function () {
        delete $window.googleMapsLoaded;
        mapsLoaded = true;
      };

      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src =
        'https://maps.googleapis.com/maps/api/js?key=AIzaSyCRm6XBTTe3YJ7trW9ncxUrXzEVz2bbWxY&v=3.exp&libraries=places&callback=googleMapsLoaded&language=en';

      document.body.appendChild(script);
    }
  });
